import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import OutOfStockArticalTable from './OutOfStockTable';
import InStockArticalTable from './InStockArticalTable';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnPagination from '@ui/components/VnPagination';
import { getAllInStockArticlesAsync, getAllOutOfStockArticlesAsync } from '@application/features/articles/ArticleThunk';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const Article = () => {
    VnDocumentTitle('Visser Artikelen');
    const [activeTab, setActiveTab] = useState('InStockArticalTable');
    const dispatch = useAppDispatch();
    const [showArticleGridHeader] = useState(true);
    const [showOutOfStockArticleGridHeader] = useState(true);
    const { inStockArticles, articleRequest, articleOutOfStockRequest, outOfStockArticles } = useAppSelector((state) => state.artical);
    const [searchArticleText, setSearchArticleText] = useState('');
    const [searchOutOfStockArticleText, setSearchOutOfStockArticleText] = useState('');
    const navigate = useNavigate();
    const handleAddArtikelenClick = () => {
        navigate(`/admin/ArticleTabs`);
    };
    const defaultSortingCriteria = {
        sortColumnKey: 'articleNumber',
        sortDirection: 'desc'
    };
    const defaultInStockArticleFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        articleNumber: null,
        name: null,
        articleGroup: null,
        brand: null,
        type: null,
        data: null,
        supplierName: null,
        supplierArticleNumber: null
    };
    const defaultOutOfStockArticleFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        articleNumber: null,
        name: null,
        articleGroup: null,
        brand: null,
        type: null,
        data: null,
        supplierName: null,
        supplierArticleNumber: null
    };
    const [inStockArticleFilterValues, setInStockArticleFilterValues] = useState(defaultInStockArticleFilterValues);
    const [outOfStockArticleFilterValues, setOutOfStockArticleFilterValues] = useState(defaultOutOfStockArticleFilterValues);
    useEffect(() => {
        if (activeTab === 'InStockArticalTable') {
            setInStockArticleFilterValues(defaultInStockArticleFilterValues);
            dispatch(getAllInStockArticlesAsync(defaultInStockArticleFilterValues));
        }
        else if (activeTab === 'OutOfStockArticalTable') {
            setOutOfStockArticleFilterValues(defaultOutOfStockArticleFilterValues);
            dispatch(getAllOutOfStockArticlesAsync(defaultOutOfStockArticleFilterValues));
        }
    }, [activeTab]);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    const onRowClick = (rowId) => {
        window.open(`/admin/ArticleTabs/${rowId}`, '_blank');
    };
    /*Filtering and Sorting region for OutOfStockTable */
    const updateOutOfStockFilterValues = (newValues) => {
        setOutOfStockArticleFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchOutOfStockArticleHandler(searchText) {
        updateOutOfStockFilterValues({ filter: searchText });
        dispatch(getAllOutOfStockArticlesAsync({
            ...outOfStockArticleFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function onOutOfStockArticlesPageChange(pageNumber) {
        updateOutOfStockFilterValues({ pageNumber });
        dispatch(getAllOutOfStockArticlesAsync({
            ...outOfStockArticleFilterValues,
            pageNumber
        }));
    }
    function OutOfStockArticlesSortingHandler(data) {
        updateOutOfStockFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllOutOfStockArticlesAsync({
            ...outOfStockArticleFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function OutOfStockArticlesFilteringHandler(data) {
        data.pageNumber = 1;
        updateOutOfStockFilterValues(data);
        dispatch(getAllOutOfStockArticlesAsync({
            ...outOfStockArticleFilterValues,
            ...data
        }));
    }
    /* Filtering and Sorting region for InStockArticleTable */
    const updateInStockFilterValues = (newValues) => {
        setInStockArticleFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchArticleHandler(searchText) {
        updateInStockFilterValues({ filter: searchText });
        dispatch(getAllInStockArticlesAsync({
            ...inStockArticleFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function onInStockArticlesPageChange(pageNumber) {
        updateInStockFilterValues({ pageNumber });
        dispatch(getAllInStockArticlesAsync({
            ...inStockArticleFilterValues,
            pageNumber
        }));
    }
    function inStockArticlesSortingHandler(data) {
        updateInStockFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllInStockArticlesAsync({
            ...inStockArticleFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function inStockArticlesFilteringHandler(data) {
        data.pageNumber = 1;
        updateInStockFilterValues(data);
        dispatch(getAllInStockArticlesAsync({
            ...inStockArticleFilterValues,
            ...data
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "Artikelen" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Artikelen', onClick: handleAddArtikelenClick, isDisabled: !handleRolePermission(Permission.ARTIKELEN, PermissionType.Create) }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InStockArticalTable', title: 'Voorraad' }), _jsx(Tab, { eventKey: 'OutOfStockArticalTable', title: 'Niet op voorraad' })] }), _jsxs("div", { className: 'mt-0', children: [activeTab === 'InStockArticalTable' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showArticleGridHeader, onSearch: searchArticleHandler }), _jsx(InStockArticalTable, { articals: inStockArticles?.items, onRowClick: onRowClick, onSorting: inStockArticlesSortingHandler, onFilter: inStockArticlesFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: inStockArticles && (_jsx(VnPagination, { currentPage: inStockArticles?.pageNumber, totalPages: inStockArticles?.totalPages, onPageChange: onInStockArticlesPageChange })) })] })), activeTab === 'OutOfStockArticalTable' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showOutOfStockArticleGridHeader, onSearch: searchOutOfStockArticleHandler }), _jsx(OutOfStockArticalTable, { articals: outOfStockArticles?.items, onRowClick: onRowClick, onSorting: OutOfStockArticlesSortingHandler, onFilter: OutOfStockArticlesFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: outOfStockArticles && (_jsx(VnPagination, { currentPage: outOfStockArticles?.pageNumber, totalPages: outOfStockArticles?.totalPages, onPageChange: onOutOfStockArticlesPageChange })) })] }))] })] }));
};
export default Article;
